import React, { Component } from 'react';
import { Provider } from 'mobx-react';
import {
  HashRouter as Router
} from 'react-router-dom';
import CreateRoutes from './routes';

class App extends Component {
  render() {
    const { context } = this.props;
    return (
      /* eslint-disable react/jsx-props-no-spreading */
      <Provider {...context}>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <CreateRoutes state={context.state} />
        </Router>
      </Provider>
    );
  }
}

export default App;
